import React, {useContext, useState} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import {useFormContext} from "react-hook-form";
import useFieldArrayClean from "../../../../../hooks/use-field-array-clean.js";
import {BoFormContext} from "../context/bo-form-context.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {v4} from "uuid";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import InputFile from "../../../../../components/input/input-file.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import BoFormCroquiMap from "./bo-form-croqui-map.jsx";

const BoFormCroqui = () => {
    const {control} = useFormContext();
    const {isSync, verifySyncUrl} = useContext(BoFormContext);

    const [modal, setModal] = useState(false);

    const {fields, append, remove} = useFieldArrayClean({
        control,
        name: "croqui.attachs"
    });

    const fileClick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = event => {
            const file = event.target.files[0];

            const previewUrl = URL.createObjectURL(file);

            const attachId = v4();

            const dataForModal = {
                name: file.name,
                type: file.type,
                extension: file.type,
                url: previewUrl,
                file: file,
                attachId: attachId,
                itemId: attachId,
                description: ""
            };

            append(dataForModal)
        }

        input.click();
    }

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Croqui e fotos</Card.Title>
                </Card.Header>

                <Card.Body className="space-y-4">
                    <section className={"space-y-4"}>
                        <FormField
                            as={InputTextarea}
                            name={"croqui.observation"}
                            label={"Observação"}
                        />

                        {
                            fields.map((item, index) => {
                                const allowRemove = isSync || !!item.url;
                                if (item && !item?.file) {
                                    item.url = `${verifySyncUrl(item.attachId)}/${item.attachId}`;
                                }

                                return (
                                    <SentryRow className="p-4 border border-[#e5e7eb] rounded-md relative" key={item.attachId}>
                                        {
                                            allowRemove &&
                                            <Button
                                                className="absolute -top-[10px] -right-[10px] !py-0 !px-0 !w-[25px] !h-[25px] z-10"
                                                target="danger"
                                                onClick={() => remove(index)}
                                            >
                                                <FaTrash />
                                            </Button>
                                        }

                                        <InputFile
                                            file={item}
                                            removeFile={() => remove(index)}
                                            isRemove={allowRemove}
                                            className={"col-span-2"}
                                        />

                                        <FormField
                                            as={InputForm}
                                            name={`croqui.attachs.${index}.description`}
                                            label={"Descrição"}
                                            disabled={!allowRemove}
                                            classNameWrapper={"col-span-10"}
                                        />
                                    </SentryRow>
                                )
                            })
                        }
                    </section>

                    <Menu as="div" className="flex items-center text-white">
                        <MenuButton type="button" className={"flex justify-center cursor-pointer h-[32px] items-center gap-1 focus:ring-2 focus:outline-none font-bold rounded-md shadow text-[13px] px-4 py-2 text-white bg-[#063A6C] hover:bg-blue-800 focus:ring-blue-300"}>
                            <FaPlus /> Adicionar croqui/fotos
                        </MenuButton>
                        <Transition
                            enter="transition ease-out duration-75"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <MenuItems
                                anchor="bottom start"
                                modal={false}
                                className="[--anchor-gap:--spacing(1)] rounded-md shadow border text-[13px] bg-white focus:outline-none z-[9999] text-gray-700 border-[#bdbdbd]"
                            >
                                <MenuItem>
                                    <button
                                        onClick={() => setModal(true)}
                                        className={"w-full text-[13px] py-2 px-4 cursor-pointer text-left text-gray-700 block text-sm hover:bg-[#063A6C] hover:text-white"}
                                    >
                                        Mapa
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        onClick={fileClick}
                                        className={"w-full text-[13px] py-2 px-4 cursor-pointer text-left text-gray-700 block text-sm hover:bg-[#063A6C] hover:text-white"}
                                    >
                                        Foto, áudio ou vídeo
                                    </button>
                                </MenuItem>
                            </MenuItems>
                        </Transition>
                    </Menu>
                </Card.Body>
            </Card>

            <BoFormCroquiMap
                open={modal}
                setOpen={setModal}
                append={append}
            />
        </>
    );
};

export default BoFormCroqui;